// styles
import './styles/graphic.scss';

import {
  axisLeft,
  axisBottom,
} from 'd3-axis';

import {
  wrapLongLabels,
} from './utils/helpers';

export default function (props, container, isMobile) {
  const {
    data,
    fmtYearAbbrev,
    fmtYearFull,
    height,
    initialWidth,
    initialHeight,
    margins,
    path,
    width,
    x,
    y,
  } = props;

  const xTicks = isMobile ? 5 : 10;
  const yTicks = 3;

  const xAxis = axisBottom(x)
    .tickValues([1972, 1980, 1990, 2000, 2010, 2018].map(d => new Date(`01/01/${d}`)))
    .tickFormat(d => (isMobile ? `‘${String(d.getFullYear()).slice(2)}` : d.getFullYear()));

  const evangelical = '#705415';
  const noReligion = '#cc0000';
  const catholic = '#c18f10';
  const mainline = '#ecae02';
  const other = '#888';


  // legend

  //   if (isMobile) {
  //     container.insert('div', ':first-child')
  //       .attr('class', 'legend')
  //       .selectAll('div')
  //       .data(data.map(d => d.id.toLowerCase()))
  //       .enter()
  //       .append('div')
  //       .attr('class', 'g-key')
  //       .html(d => `
  //         <span
  //           class='block'
  //           style='background-color:${
  //   d === 'no religion'
  //     ? noReligion
  //     : d === 'evangelical'
  //       ? evangelical
  //       : d === 'catholic'
  //         ? catholic
  //         : d === 'other affiliations'
  //           ? other
  //           : mainline
  // };'></span> ${d}`);
  //   }


  // svg
  const svg = container.append('svg')
    .attr('width', initialWidth)
    .attr('height', initialHeight);

  const g = svg.append('g')
    .attr('transform', `translate(${[margins.left, margins.top]})`);

  // x axis
  const xGrid = g.append('g')
    .attr('class', 'grid x')
    .attr('transform', `translate(${[0, height]})`)
    .call(xAxis);


 	// y axis
  const yGrid = g.append('g')
    .attr('class', 'grid y')
    .call(axisLeft(y).ticks(yTicks).tickValues([0, 0.1, 0.2, 0.3, 0.4]));

  yGrid.select('text').style('display', 'none'); // hide first tick's text
  yGrid.selectAll('line').attr('x2', width);

  yGrid.selectAll('text')
    .attr('text-anchor', 'start')
    .attr('x', -margins.left + 3)
    .text(d => `${(d * 100).toFixed(0)}%`);

  // lines
  const lines = g.append('g')
    .attr('class', 'lines')
    .selectAll('g')
    .data(data)
    .enter()
    .append('g')
    .attr('class', 'line');

  lines.append('path')
    .style('stroke-width', d => (
      d.id.toLowerCase() === 'no religion' /* || d.id.toLowerCase() === 'evangelical' ||  d.id.toLowerCase() === 'catholic' */
        ? isMobile ? 2.25 : 3
        : isMobile ? 1.5 : 2
    ))
    .style('stroke-opacity', d => (d.id.toLowerCase() === 'jewish' || d.id.toLowerCase() === 'other faith' ? 0 : 1))
    .attr('stroke', (d, i) => {
      switch (d.id.toLowerCase()) {
        case 'evangelical': {
          return evangelical;
        }
        case 'no religion': {
          return noReligion;
        }
        case 'catholic': {
          return catholic;
        }
        case 'mainline protestant': {
          return mainline;
        }
        default: {
          return other;
        }
      }
    })
    .attr('d', d => path(d.values));

  // labels
  const labels = g.append('g')
    .attr('class', 'data-label');

  const names = g.append('g')
    .attr('class', 'names');

  const label = labels.selectAll('g')
    .data(d => data.map(d => ({
      ...d,
      values: d.values
        .filter((d, i, arr) => i === 0 || i === arr.length - 1)
        .map(v => ({
          ...v,
          id: d.id.toLowerCase(),
        })),
    })))
    .enter().append('g')
    .style('fill', (d, i) => (i % 2 === 0 ? mainline : other))
    .selectAll('g')
    .data(d => d.values)
    .enter()
    .append('g')
    .attr('transform', d => `translate(${[x(d.date), y(d.value)]})`);


  label.append('circle')
    .attr('r', 3)
    .attr('stroke', '#f2f2f2')
    .style('fill', (d, i) => {
      switch (d.id.toLowerCase()) {
        case 'evangelical': {
          return evangelical;
        }
        case 'no religion': {
          return noReligion;
        }
        case 'catholic': {
          return catholic;
        }
        case 'mainline protestant': {
          return mainline;
        }
        default: {
          return other;
        }
      }
    });

  label.append('text')
    .attr('text-anchor', (d, i) => (i === 0 ? 'end' : null))
    .attr('y', (d, i) => {
      // console.log(d, i);
      switch (d.id) {
        case 'evangelical': {
          if (i === 1) return '1em';
          return 0;
        }
        case 'mainline protestant': {
          if (i === 0) return '-.5em';
          return 0;
        }
        case 'black protestant': {
          if (i === 1) return '-.5em';
          return 0;
        }
        case 'catholic': {
          if (i === 0) return '.5em';
          return '.35em';
        }
        case 'other affiliations': {
          if (i === 1) return 0;
          return '-.5em';
        }
        case 'no religion': {
          if (i === 0) return '0em';
          return '-.65em';
        }
        default: {
          return 0;
        }
      }
    })
    .attr('dx', (d, i) => (i === 0 ? '-.35em' : 0))
    .attr('dy', '.35em')
    .style('fill', (d) => {
      switch (d.id.toLowerCase()) {
        case 'evangelical': {
          return evangelical;
        }
        case 'no religion': {
          return noReligion;
        }
        case 'catholic': {
          return catholic;
        }
        case 'other affiliations': {
          return other;
        }

        default: {
          return mainline;
        }
      }
    })
    .style('font-weight', d => ((d.id === 'no religion') ? 'bold' : null))
    .html((d, i) => {
      const v = (d.value * 100).toFixed(0);
      const s = String(v).replace('.0', '');

      if (i === 1 && (d.id === 'mainline protestant' || d.id === 'other affiliations')) {
        return `
          <tspan x='.35em'>${s}</tspan>
          ${d.id.split(' ').map((line, i2) => `<tspan x=${i2 === 1 ? '1.7em' : null} dy='${i2 * 1.1}em'>${line.charAt(0).toUpperCase() + line.slice(1)}</tspan>`).join('')}
        `;
      }

      if (i === 1) return `<tspan x='.35em'>${s}</tspan><tspan> ${i === 1 ? d.id : ''}</tspan>`;

      return s;
    });
}
